import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Snackbar from '@mui/material/Snackbar';
import constants from 'helpers/constants';
import utils from 'helpers/utils';

const StyledActionbar = styled(Snackbar)
  .attrs((props) => {
    let attr = props;

    const paperColorVars = props.theme.color2Css('Actionbar', 'Actionbar-content', props.$color, {
      varPrefix: 'actionbar',
      variables: true,
      type: constants.colorTypes.paper
    });

    attr = utils.styleProps(attr, paperColorVars.vars, {paperColor: paperColorVars.css});

    const vars = {
      '--actionbar-title-color': props.theme.property('palette.white.main'),
      '--actionbar-disabled-color': props.theme.property('palette.action.disabled'),
      '--actionbar-bounds-right': props.$wrapper?.boundsCum?.right ?? '0px',
      '--actionbar-bounds-left': props.$wrapper?.boundsCum?.left ?? '0px'
    };

    return utils.styleProps(attr, vars);
  })`
  pointer-events: none;
  z-index: ${props => props.theme.property('zIndex.actionbar')};
  
  ${props => props.$css.paperColor}

  width: calc(100vw - (2 * max(${props => props.$css.$var('--actionbar-bounds-left')}, ${props => props.$css.$var('--actionbar-bounds-right')})));
  padding: 0 ${props => props.theme.spacing(3)};
  
  .Actionbar-content {
    display: flex;
    flex-wrap: nowrap;
    white-space: nowrap;
    pointer-events: all;
    border-radius: ${props => props.theme.radius(2)};  
    padding: calc(${props => props.theme.spacing(2)} - 1px) ${props => props.theme.spacing(2)};
    
    .Actionbar-title {
      display: flex;
      align-items: center;
      margin-right: ${props => props.theme.spacing(8)};
      color: ${props => props.$css.$var('--actionbar-title-color')};
      
      &-text {
        font-size: 1rem;
        align-self: center;
        margin-right: ${props => props.theme.spacing(1)};
      }
    }
    
    .Actionbar-actions {
      display: flex;
      flex-wrap: wrap;
      gap: ${props => props.theme.layout('1sp')};
    }
  }

  ${props => props.theme.breakpoints.down('lg')} {
    .Actionbar-content {
      .Actionbar-title {
        margin-right: ${props => props.theme.spacing(6)};
      }
    }
  }

  ${props => props.theme.breakpoints.down('md')} {
    .Actionbar-content {
      .Actionbar-title {
        margin-right: ${props => props.theme.spacing(4)};
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledActionbar.propTypes = {
};

export default StyledActionbar;
